module.exports = __webpack_public_path__ + "static/media/availability_comparative_per_month.710ecdd2.svg";